export class AdminKycApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The scoped manual-review queue for a market (documents awaiting a human decision). Operator KYC-review. */
    reviewQueue(market) {
        const qs = market !== undefined && market !== '' ? `?market=${encodeURIComponent(market)}` : '';
        return this.client.request({ method: 'GET', path: `/v1/kyc/review-queue${qs}`, auth: true });
    }
    /** Approve or reject a document awaiting manual review (reason recommended on reject). Operator KYC-review. */
    decide(documentId, decision, reason) {
        return this.client.request({
            method: 'POST',
            path: `/v1/kyc/documents/${encodeURIComponent(documentId)}/decision`,
            body: { decision, ...(reason !== undefined && reason !== '' ? { reason } : {}) },
            auth: true,
        });
    }
}
//# sourceMappingURL=admin-kyc.js.map